module.exports = __webpack_public_path__ + "img/23.8d48b092.png";